import { render, staticRenderFns } from "./FilesStudentDialog.vue?vue&type=template&id=37ab322c&scoped=true"
import script from "./FilesStudentDialog.vue?vue&type=script&lang=js"
export * from "./FilesStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./FilesStudentDialog.vue?vue&type=style&index=0&id=37ab322c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab322c",
  null
  
)

export default component.exports